module.exports = __webpack_public_path__ + "static/media/XXVIIe.e3eac3e6.png";